var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.063 0.332397C21.018 0.332397 23.6663 3.10906 23.6663 7.23906V16.7719C23.6663 20.8902 21.018 23.6657 17.063 23.6657H6.94801C2.99301 23.6657 0.333008 20.8902 0.333008 16.7719V7.23906C0.333008 3.10906 2.99301 0.332397 6.94801 0.332397H17.063ZM15.5113 8.46523C15.1147 8.0674 14.473 8.0674 14.0647 8.46523L11.9997 10.5407L9.92301 8.46523C9.51467 8.0674 8.87301 8.0674 8.47634 8.46523C8.07967 8.8619 8.07967 9.51523 8.47634 9.91073L10.553 11.9886L8.47634 14.0536C8.07967 14.4619 8.07967 15.1036 8.47634 15.4991C8.67467 15.6974 8.94301 15.8036 9.19967 15.8036C9.46801 15.8036 9.72467 15.6974 9.92301 15.4991L11.9997 13.4352L14.0763 15.4991C14.2747 15.7102 14.5313 15.8036 14.788 15.8036C15.0563 15.8036 15.313 15.6974 15.5113 15.4991C15.908 15.1036 15.908 14.4619 15.5113 14.0652L13.4347 11.9886L15.5113 9.91073C15.908 9.51523 15.908 8.8619 15.5113 8.46523Z",
    fill: "#C33235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastError);
export default __webpack_public_path__ + "static/media/toastError.bf85d3acde950b6ee7fdd8a71f44cf70.svg";
export { ForwardRef as ReactComponent };